export default __webpack_public_path__ + "static/media/jsperkimdinas.7065a206.png";